import { useMemo } from 'react';

import useForm from '../utils/useForm';

const usePrincipalPaymentForm = (onSubmit, bankAccountId, bankAccounts) => {
  const fields = useMemo(
    () => [
      {
        title: 'Principal Payment',
        fields: [
          {
            title: 'Amount',
            name: 'amount',
            type: 'currency',
            required: true,
          },
          {
            title: 'Bank Account',
            name: 'bank_account_id',
            type: 'select',
            options: bankAccounts?.map((account) => {
              return {
                value: account.id,
                label: `${account?.account_number?.replace(
                  /.(?=.{4})/g,
                  '* '
                )} ${account.id === bankAccountId ? ' (primary)' : ''}`,
              };
            }),
            defaultValue: bankAccountId,
            isHidden: () => !bankAccounts || bankAccounts.length < 2,
          },
        ],
      },
    ],
    [bankAccountId, bankAccounts]
  );

  const { formik } = useForm({ fields, onSubmit });

  return { formik, fields };
};

export default usePrincipalPaymentForm;
